import React, {Component} from 'react';
import {
    BrowserRouter as Router
} from 'react-router-dom';
import App from "./App";

class Routing extends Component {
    render() {
        return (
            <Router>
                <App {...this.props} />
            </Router>
        );
    }
}

export default Routing;



// WEBPACK FOOTER //
// ./src/Routing.js